import React, { Fragment, useState, useEffect } from 'react';
import { withRouter } from "react-router-dom";
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { Breadcrumb, BreadcrumbItem, CardHeader } from 'reactstrap';
import moment from 'moment';
import 'moment-timezone';

import classnames from 'classnames';
import Capability from './Capability';
import { Beforeunload } from 'react-beforeunload';
import { Typeahead } from 'react-bootstrap-typeahead';
import axios, { post } from 'axios';
import * as FileSaver from 'file-saver';
import SweetAlert from 'react-bootstrap-sweetalert';
import ReactGA from 'react-ga';
import config from '../../config/okta.config';
import {
  Nav, NavItem, NavLink, Modal, ModalHeader, ModalBody, ModalFooter, Progress, FormFeedback,Row,
  InputGroup, FormGroup, Label, Input, ButtonToggle, Spinner, UncontrolledTooltip, TabContent, TabPane
} from 'reactstrap';
import FileUploaderObj from './fileuploader'
import XLSX from 'xlsx';
import {
  Col,
  Card,CardTitle,CardText,
  CardBody, Button, InputGroupAddon
} from 'reactstrap';
import { Form, FormText } from 'reactstrap';
import { withAuth } from '@okta/okta-react';

import gql from 'graphql-tag';
import { useLazyQuery, useMutation, useQuery } from '@apollo/react-hooks';
import { ConstantLine } from 'devextreme-react/chart';
import DataTable from 'react-data-table-component'
import FileUploaderObjGeneric from './fileuploaderGeneric'

//Get Supplier certificates call config
const GET_LOTS = gql`
query GetLots($ILNum: String) {
  vwAppinspectionlotnew(filters:{
    ILNum: $ILNum
  }) {
    edges {
      node {
        ILNum
        PODocNum
        PlanID
       PartNum
       PartDesc
        PartRev
        DBNum
        Plant
        OpenCloseFlag
       ILUDCodeDate
       ILStartDate
       ILEndDate
       VendorNum
       VendorBatch
       VendorName
       iInspectionlotnum
       iInspectionid
       iStatus
       iVendorbatch
       InspModeCode
       InspMode
       InspModeDisplayName
       LotQty
       CurWorkingInspectorID
       FileGUID
       OpenCloseFlag
       ILStatusDisp
       LifeCyclePhase
       Platform 
       Businessunit
       VCODE
       UDCode
       ILCommentsCount
       StorageLocation
       SAPStage
       SAPUDCode
       NPIStoragelocation
       NPIIqcCriteria
       FAIRCheckRequired
       FAIRInspection
       EngineeringInspection
       FAIRApprovedCheck
       FAINENGType
       NPIIqcCriterianame
       DESIGNCONTROL
       MvmtType 
       MatrlDocNo 
       IsReRecieveLot 
       PreviousMaterDocNo
       PreviousMvmtType 
      }
    }
  }
}
`;



const GET_NOTIFICATIONS = gql`
      query getInspections($VendorNum: String, $NotifType: String, $VendorResponsible: String){
        vwNotifications(filters: {
            NotifType: $NotifType
            VendorNum: $VendorNum
            VendorResponsible: $VendorResponsible
          }, sort: CREATED_DATE_DESC) { 
            edges {
              node {
                NotifNum
                NotifType
                NotifDate
                NotifOrigin
                NotifStatus
                NotifSubType
                InspLotNum
                MaterialNum
                RevLvl
                
                VendorNum
                VendorName
                VendorMaterialNum
                VendorResponsible
                Severity
                AssetNum
                Description
                QmOrder
                ActualQty
                RefQty
                VendorMaterialNum
                Manufacturer
                CreatedBy
                CreatedDate
                ChangedBy
                ChangedDate
                BuyerDescr
                ComplaintQty
                PurchaseOrderNum
                MfgCell
                SAPStage
                ILUDCode 
                ILUDCodeDate
                ILUDGroup
                ILUDMode
                ILUDMadeBy
                ILUDChangedBy
                ILUDChangedDate
              }
            }
          }
        }
  

  `;


  const GET_NOTIFICATION_TASKS = gql`
      query getNotificationTasks($NotifNum: ID){
        vwNotificationtasks(filters: {
            NotifNum: $NotifNum
           
          }) { 
            edges {
              node {
                NotifNum
                TaskNum
                SAPTaskNum
                TaskStatus
                CatalogTypeTasks
                CodeGroupTask
                TaskCode
                TaskCodeText
                TaskText
                CompletedBy
                Responsible
                CompletionDate
                PlannedStartDate
                PlannedEndDate
                PlannedStartTime
                PlannedEndTime
                Version
                ChangedBy
                ChangedOn
                CreatedOn
                DWLoadTS
                DWUpdateTS
              }
            }
          }
        }
  

  `;

  const GET_NOTIFICATION_TEXT = gql`
      query vwNotificationstasktext($NotifNum: ID){
        vwNotificationstasktext(filters: {
            NotifNum: $NotifNum
           
          }) { 
            edges {
              node {
                NotifNum
                    TaskNum
                    SRTF2
                    TaskText
                    Clustr
                    TDObject
              }
            }
          }
        }
  

  `;



//Start main code
const FAIRNotifications = ({ history }) => {
    const [showLoading, setShowLoading] = useState(null);
    const [NotificationData, setNotificationData] = useState(null);
    const [notificationText,setNotificationText] = useState(null);
    const [notificationTasks,setNotificationTasks] = useState(null);
    const [selectedNotification,setSelectedNotification] = useState(null);
    const [activeTab, setActiveTab] = useState('1');
    const [lots,setLots] = useState(null);

      // Get list of OPEN PO for the logged in vendor
  const { data } = useQuery(GET_NOTIFICATIONS, {
    fetchPolicy: 'no-cache',
    variables: { VendorNum:localStorage.getItem('loggedInVendor'), 'NotifType': 'IQ','VendorResponsible':'Y' }, // NotifiType: NR, NotifSubtype: 'SC'
    onCompleted: (data) => {
       
        setShowLoading(false);
        setNotificationData(data.vwNotifications.edges);
       
    }
  });

       //Get List of certificates 
       const [GetInspectionLots] = useLazyQuery(GET_LOTS, {
        fetchPolicy: 'no-cache',
        onCompleted: (data) => {
          setLots(data.vwAppinspectionlotnew.edges);
        },
        onError: (error) => {
          console.log(error)
        }
      });
  

        useEffect(() => {
        if (!NotificationData) {
            setShowLoading(true);
        } else {
            setShowLoading(false);
        }
        });

    const navigateHome = () => {
   
        history.push({
          pathname: '/supplier/LandingPage'
        });
     
    }

    const navigateVRNotif = () => {
        setNotificationTasks(null);
        setNotificationText(null);
        history.push({
            pathname: '/supplier/FAIRNotifications'
          });
    }

    const taskcolumns = [
        {
            name: 'TaskNum',
            selector: 'node.TaskNum',
            sortable: true,
            style: {
                color: '#202124',
              fontSize: '14px',
              fontWeight: 500,
            }
          }, 
        {
          name: 'TaskCode',
          selector: 'node.TaskCode',
          sortable: true,
          style: {
              color: '#202124',
            fontSize: '14px',
            fontWeight: 500,
          }
        }, {
            name: 'TaskCodeText',
            selector: 'node.TaskCodeText',
            grow:2,
            format: (row) =>  <span>{row.node.TaskCodeText}</span>,    
            sortable: true,
            style: {
                color: '#202124',
              fontSize: '14px',
              fontWeight: 500,
            }
          }, {
            name: 'TaskStatus',
            selector: 'node.TaskStatus',
            sortable: true,
            style: {
                color: '#202124',
              fontSize: '14px',
              fontWeight: 500,
            }
          }, {
            name: 'TaskText',
            selector: 'node.TaskText',
            sortable: true,
            style: {
                color: '#202124',
              fontSize: '14px',
              fontWeight: 500,
            }
          }, {
            name: 'CodeGroupTask',
            selector: 'node.CodeGroupTask',
            sortable: true,
            style: {
                color: '#202124',
              fontSize: '14px',
              fontWeight: 500,
            }
          }, {
            name: 'PlannedStartDate',
            selector: 'node.PlannedStartDate',
            sortable: true,
            style: {
                color: '#202124',
              fontSize: '14px',
              fontWeight: 500,
            }
          }, {
            name: 'PlannedEndDate',
            selector: 'node.PlannedEndDate',
            sortable: true,
            style: {
                color: '#202124',
              fontSize: '14px',
              fontWeight: 500,
            }
          }, {
            name: 'CreatedOn',
            selector: 'node.CreatedOn',
            sortable: true,
            style: {
                color: '#202124',
              fontSize: '14px',
              fontWeight: 500,
            }
          }, {
            name: 'CompletedBy',
            selector: 'node.CompletedBy',
            sortable: true,
            style: {
                color: '#202124',
              fontSize: '14px',
              fontWeight: 500,
            }
          }, {
            name: 'CompletionDate',
            selector: 'node.CompletionDate',
            sortable: true,
            style: {
                color: '#202124',
              fontSize: '14px',
              fontWeight: 500,
            }
          }, {
            name: 'ChangedBy',
            selector: 'node.ChangedBy',
            sortable: true,
            style: {
                color: '#202124',
              fontSize: '14px',
              fontWeight: 500,
            }
          },{
            name: 'ChangedOn',
            selector: 'node.ChangedOn',
            sortable: true,
            style: {
                color: '#202124',
              fontSize: '14px',
              fontWeight: 500,
            }
          }]




    const columns = [
        {
          name: 'Notification #',
          selector: 'node.NotifNum',
          sortable: true,
          style: {
              color: '#202124',
            fontSize: '14px',
            fontWeight: 500,
          }
        },
        {
          name: 'Description',
          selector: 'node.Description',
          selector: 'ILStartDate',
          format: (row) =>  <span>{row.node.Description}</span>,    
          sortable: true,
          style: {
            color: '#202124',
            fontSize: '14px',
            fontWeight: 500,
          }
        },
        {
          name: 'Material #',
          selector: 'node.MaterialNum',
          sortable: true,
          style: {
            color: '#202124',
            fontSize: '14px',
            fontWeight: 500,
          }
        },
        {
          name: 'Revision',
          selector: 'node.RevLvl',
          sortable: true,
          style: {
            color: '#202124',
            fontSize: '14px',
            fontWeight: 500,
          }
        }, {
            name: 'Status',
            selector: 'node.NotifStatus',
            sortable: true,
            style: {
              color: '#202124',
              fontSize: '14px',
              fontWeight: 500,
            }
          },
        {
          name: 'Created By',
          selector: 'node.CreatedBy',
          sortable: true,
          style: {
            color: '#202124',
            fontSize: '14px',
            fontWeight: 500,
          }
        },
        {
          name: 'Created Date',
          selector: 'node.CreatedDate',
          sortable: true,
          style: {
            color: '#202124',
            fontSize: '14px',
            fontWeight: 500,
          }
        },
        {
          name: 'Actual Qty',
          selector: 'node.ActualQty',
          sortable: true,
          style: {
            color: '#202124',
            fontSize: '14px',
            fontWeight: 500,
          }
        },
        {
          name: 'Severity',
          selector: 'node.Severity',
          sortable: true,
          style: {
            color: '#202124',
            fontSize: '14px',
            fontWeight: 500,
          }
        },{
            name: '',
            button: true,
            cell: (row) => <button onClick={() => viewNotification(row)} style={{marginLeft:'15px',width:'100px',color:'white',backgroundColor:'blue'}}>View</button>,
          }
        ];

        const [getNotificationTasks] = useLazyQuery(GET_NOTIFICATION_TASKS, {
            fetchPolicy: 'no-cache',
            onCompleted: (data) => {
              setNotificationTasks(data.vwNotificationtasks.edges);
            
            }
          });

          const [getNotificationText] = useLazyQuery(GET_NOTIFICATION_TEXT, {
            fetchPolicy: 'no-cache',
            onCompleted: (data) => {
              setNotificationText(data.vwNotificationstasktext.edges);
            
            }
          });
  
const viewNotification = (row) => {
  GetInspectionLots({ variables: { ILNum: row.node.InspLotNum.substring(1) } });
    setSelectedNotification(row);
    getNotificationText({ variables: { NotifNum: row.node.NotifNum } });
    getNotificationTasks({ variables: { NotifNum: row.node.NotifNum } });
}


const notesHTML = (!notificationText) ? null : 
    notificationText.map((el,i) => {
        return (
        <li>{el.node.TaskText}</li>
        )
    });

    


const VRDetailHeader = (!selectedNotification) ? null :
<table className="align-middle mb-0 table table-borderless table-striped table-hover">
    <thead>
        <tr>
            <th>Notification #</th>
            <th>VendorName</th>
            <th>PartNum</th>
            <th>Quantity</th>
            <th>Inspection Stage</th>
            <th>Created Date</th>
            <th>IQ Notification</th>
            <th>FAIR Status</th>
        </tr>
    </thead>
    <tbody>
        <tr>
            <td style={{textAlign:'center'}}>{selectedNotification.node.NotifNum}</td>
            <td style={{textAlign:'center'}}>{selectedNotification.node.VendorNum} {selectedNotification.node.VendorName}</td>
            <td style={{textAlign:'center'}}>{selectedNotification.node.MaterialNum} - {selectedNotification.node.Description}</td>
            <td style={{textAlign:'center'}}>{selectedNotification.node.ActualQty}</td>
            <td style={{textAlign:'center'}}>{selectedNotification.node.SAPStage}</td>
            <td style={{textAlign:'center'}}>{selectedNotification.node.CreatedDate}</td>
            <td style={{textAlign:'center'}}>N/A</td>
            <td style={{textAlign:'center'}}>{selectedNotification.node.ILUDCode}</td>
           
        </tr>
    </tbody>
</table>;

const toggle = tab => {
    console.log(tab)
    if (activeTab !== tab) setActiveTab(tab);
  }


return (
    <Fragment>
      <Beforeunload onBeforeunload={() => "You'll lose your data!"} />

      <ReactCSSTransitionGroup
        component="div"
        transitionName="TabsAnimation"
        transitionAppear={true}
        transitionAppearTimeout={0}
        transitionEnter={false}
        transitionLeave={false}
      >

<Breadcrumb>
          <BreadcrumbItem style={{ paddingTop: "0.5rem" }}>
            <a href="javascript:void(0);" onClick={navigateHome}>
              Home
            </a>{" "}
          </BreadcrumbItem>
          <BreadcrumbItem style={{ paddingTop: "0.5rem" }} active>
          <a href="javascript:void(0);" onClick={navigateVRNotif}> FAIR Notifications </a>
          </BreadcrumbItem>
            {(notificationTasks && notificationText)?
          <BreadcrumbItem style={{ paddingTop: "0.5rem" }} active>
            FAIR Details
          </BreadcrumbItem>: null}

          </Breadcrumb>
          { (NotificationData && (!notificationTasks || !notificationText)) ?
          <Card style={{margin:'2%'}}>
            <CardHeader>FAIR Notifications</CardHeader>

            <CardBody>
            <div className="table-responsive">
                          <DataTable
                            title="Google Sheets-esqe"
                            columns= {columns}
                            data={NotificationData}
                            highlightOnHover                 
                            pointerOnHover
                            pagination
                          />
                  </div>

            </CardBody>

          </Card>: (notificationTasks && notificationText && NotificationData)? 
             <>   <Card style={{margin:'2%'}}>
                    <CardHeader>Inspection Lot Details</CardHeader>
                    <CardBody>
                        {VRDetailHeader}

                  
                        <div>
  <Nav tabs style={{margin:'1%'}}>
    <NavItem>
      <NavLink
        className="active"
        onClick={() =>toggle('1')}
        className={classnames({ active: activeTab === "1" })}
      >
        FAIR Details
      </NavLink>
    </NavItem>
    
    <NavItem>
      <NavLink
         className={classnames({ active: activeTab === "3" })}
        onClick={() =>toggle('3')}
      >
        Attachments
      </NavLink>
    </NavItem>
  </Nav>
  <TabContent activeTab={activeTab}>
    <TabPane tabId="1">

    <Row>
        <Col>
         <Form>
                <FormGroup row>
                    <Label
                    for="materialNumber"
                    sm={2}
                    >
                    UD Date
                    </Label>
                    <Col sm={10} style={{display:'flex', alignItems:'center'}}>
                        {selectedNotification.node.ILUDCodeDate}
                    </Col>
                </FormGroup>
                <FormGroup row>
                    <Label
                    for="examplePassword"
                    sm={2}
                    >
                    Inspection Lot #
                    </Label>
                    <Col sm={10} style={{display:'flex', alignItems:'center'}}>
                    {(selectedNotification.node.InspLotNum)?selectedNotification.node.InspLotNum:'N/A'}  
                    </Col>
                </FormGroup>
                <FormGroup row>
                    <Label
                    for="examplePassword"
                    sm={2}
                    >
                    Inspection Stage
                    </Label>
                    <Col sm={10} style={{display:'flex', alignItems:'center'}}>
                    {(selectedNotification.node.SAPStage)?selectedNotification.node.SAPStage:'N/A'}   
                    </Col>
                </FormGroup>
                <FormGroup row>
                    <Label
                    for="examplePassword"
                    sm={2}
                    >
                    Quantity
                    </Label>
                    <Col sm={10} style={{display:'flex', alignItems:'center'}}>
                    {(selectedNotification.node.ActualQty)?selectedNotification.node.ActualQty:'N/A'} 
                    </Col>
                </FormGroup>
                <FormGroup row>
                    <Label
                    for="examplePassword"
                    sm={2}
                    >
                    Purchase Order #
                    </Label>
                    <Col sm={10} style={{display:'flex', alignItems:'center'}}>
                    {(selectedNotification.node.PurchaseOrderNum)?selectedNotification.node.PurchaseOrderNum:'N/A'} 
                    </Col>
                </FormGroup>

                <FormGroup row>
                    <Label
                    for="examplePassword"
                    sm={2}
                    >
                    FAIR Status
                    </Label>
                    <Col sm={10} style={{display:'flex', alignItems:'center'}}>
                    {(selectedNotification.node.ILUDCode)?selectedNotification.node.ILUDCode:'N/A'}   
                    </Col>
                </FormGroup>

          
  </Form>
  </Col>
  <Col>
            <Card>
                <CardHeader>Notes</CardHeader>
                <CardBody>
                    <ul>{notesHTML}</ul>
                </CardBody>
            </Card>
  </Col>
    </Row>
  

        
         
   
    </TabPane>
  
    <TabPane tabId="3">
    <FileUploaderObjGeneric mode="FAIRNotifications" header={selectedNotification} data={selectedNotification}/>

    </TabPane>
  </TabContent>
</div>

                        </CardBody>

                    </Card></>
            : null}

      </ReactCSSTransitionGroup>

      {(showLoading) ? 
      <Modal isOpen={showLoading} style={{ backgroundColor: "transparent" }}>
        <ModalBody>
          <div
            style={{
              width: "100%",
              textAlign: "center",
              marginTop: "20px",
              verticalAlign: "center",
            }}
          >
            <div
              style={{
                marginLeft: "auto",
                marginRight: "auto",
                verticalAlign: "center",
              }}
              class="loader"
            ></div>
            Loading Notifications .....
          </div>
        </ModalBody>
      </Modal>
      : null}
      
      </Fragment>

)
}

export default (withRouter(withAuth(FAIRNotifications)))
